var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43209"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 105",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "rotate(-180 14 14)",
    fill: "#05BC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 7L10 14L17 21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBackIcon);
export default __webpack_public_path__ + "static/media/sidebarBackIcon.7861cd59d46e30c23899cd64c9de3788.svg";
export { ForwardRef as ReactComponent };